import { graphConfig } from "../authConfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken) {
  const headers = new Headers();
  let bearer = `Bearer ${accessToken}`;

  const companyId = sessionStorage.getItem('companyId');
  if(companyId !== null 
      && 
      companyId !== undefined
      && localStorage.getItem(`pterotoken_${companyId}`) !== null
  ){
    bearer = `Bearer ${localStorage.getItem(`pterotoken_${companyId}`)}`;
  }

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers: headers,
  };

  return fetch(graphConfig.graphMeEndpoint, options)
    .then((response) => response.json())
    .catch((error) => console.log(error));
}
